// extracted by mini-css-extract-plugin
export var logoWrapper = "dt_nX";